import { useNavigate } from "react-router-dom";
import Table from "../../../../Components/Tables/Table";
import PageHeader from "../../../../Layout/PageHeader";
import { usePagination } from "../../../../hooks/usePagination";
import { useEffect, useState } from "react";
import { ApiResponse } from "../../../../model/common/apiResponse";
import { useSearchStore } from "../../../../store/search/searchStore";
import Loader from "../../../../Components/GlobalLoader/Loader";
import { toast, Toaster } from 'react-hot-toast';
import Pagination from "../../../../Shared/Pagination/Pagination";
import Card from "../../../../Shared/Cards/Card";
import { InventoryListProps } from "../model/inventory-common.model";
import { fetchList } from "../service/inventory-common.service";
import { useSorting } from "../../../../hooks/useSorting"; 



const InventoryList: React.FC<InventoryListProps> = ({
    pageName,
    columns,
    addUrl,
    listUrl,
    gridUrl,
    search_columns,
    db_columns,
    data: parentData,
    listEndpoint,
    sorting_order,
    clientId
}) => {
    const navigation = useNavigate();
    const { currentPage, handlePageChange, perPage } = usePagination();
    const [data, setData] = useState<ApiResponse<any> | null>(parentData || null);
    const { searchTerm, resetSearch, previousSearchTerm, setPreviousTerm } =
    useSearchStore();
    const { sortingData, handleSortChange } = useSorting(handlePageChange);
    const [loading,setLoading] = useState<boolean>(false);
    useEffect(() => {
         setData(null);
        resetSearch();
      }, [ resetSearch]);
      useEffect(() => {
        setData(null);
        if (searchTerm != previousSearchTerm && currentPage != 1) {
          handlePageChange(1);
        }
    
        let order: any[] = [];
        if (sortingData.column.column_name && sortingData.direction) {
          order = [
            {
              column: sortingData.column.column_name,
              dir: sortingData.direction,
            },
          ];
        }
        let filterPayload: any[] = [];
        if (clientId) {
          filterPayload.push(["item.client_id", "=", clientId]);
        }
        const payload: any = {
          columns: db_columns,
          conditions:filterPayload,
          limit: perPage,
          page: currentPage,
          search: searchTerm,
          order: sorting_order,
        };
        if (order.length > 0) {
          Object.assign(payload, { order });
        }
        if (search_columns.length > 0) {
          Object.assign(payload, { search_columns });
        }
           
            fetchList(listEndpoint,payload).then((response:any) => {
                setData(response?? null);
                setPreviousTerm(searchTerm);
            });
      }, [currentPage, searchTerm,sortingData,clientId]);



    return data ? (
              <>
                    <Toaster />
                    <PageHeader
                        addUrl={addUrl}
                        name={pageName}
                        hideAddButton={true}
                    />
                    <div className="clearfix"></div>
                                <h5 className="text-start">{pageName}</h5>
                                <div className="customerTableMainDiv">
                                    <Table columns={columns} data={data?.data?.results || []}
                                    sortingData={sortingData}
                                    onSortChange={handleSortChange}
                                    enableSorting={true}
                                    pagination={{
                                        recordsPerPage: perPage,
                                        totalRecords: data?.data?.recordsTotal,
                                        currentPage: currentPage,
                                        onCurrentPageChange: handlePageChange,
                                      }}
                                      CheckboxStatus={false}
                                    />
                                </div>
              </>
            ) : <Loader />;
}
export default InventoryList;